import React from 'react';
import {SelectBase} from '../../components/select/mui-base';
import {FIND_ALL_CIDADE as query} from '../../graphql/queries';

const getVariables = ({pageNumber, search = '', searchDTO = {}, pageSize = 10}) => {
  return {
    pageable: {
      pageNumber,
      pageSize,
      orderBy: [
        {
          campo: 'nome',
          ordem: 'ASC',
        },
        {
          campo: 'id',
          ordem: 'ASC',
        },
      ],
    },
    searchDTO: {
      ...searchDTO,
      search,
    },
  };
};

export const SelectCidades = ({searchDTO, ...props}) => {
  return (
    <SelectBase
      label="Cidade"
      responseObjectName="findAllCidade"
      getVariables={(props) => getVariables({searchDTO, ...props})}
      labelProp="label"
      query={query}
      {...props}
    />
  );
};
